import {Form} from "../../helpers/forms/Form";
import {initTomSelectInput} from "../../helpers/inputs/tom-select/tom-select";
import {getSingleInputElementByNameV3} from "../../helpers/forms/formInputsHelpers";
import {initFlatPickerInput} from "../../helpers/inputs/flatPicker/flatPicker";

// noinspection JSUnusedGlobalSymbols -- Imported via d.ts
class PublicOffSeasonAuditionRequestPersonalForm extends Form {
	constructor(config) {
		super({
			fields: [
				'first_name',
				'last_name',
				'address',
				'city',
				'state',
				'zip',
				'phone',
				'email',
				'gender',
				'date_of_birth',
				'has_worked_before',
				'type',
			],
			...config,
		});

		// Setup audition type
		/** @var {HTMLInputElement} */
		this.auditionTypeSelect = getSingleInputElementByNameV3(this.config.formElement, 'type');

		this.auditionTypeSelectInstance = initTomSelectInput(this.auditionTypeSelect, {
			allowEmptyOption: false,
			onDropdownOpen: () => {
				setTimeout(() => this.scrollFormToBottom())
			}
		})

		// Setup DOB picker
		this.dobElement = getSingleInputElementByNameV3(this.config.formElement, 'date_of_birth');

		initFlatPickerInput(this.dobElement, {
			enableTime: false,
			maxDate: 'today',
		});
	}

	scrollFormToBottom() {
		// Get inmediate parent and scroll it down
		const parent = this.config.formElement.parentElement;

		// Scroll to bottom
		parent.scrollTop = parent.scrollHeight + 100;
	}
}

export {PublicOffSeasonAuditionRequestPersonalForm}
